/**
 * safeAxios — axios wrapper that routes every request through the shared
 * url-guard validation (the same SSRF/host-allowlist policy safeFetch uses),
 * then delegates to axios so callers keep axios ergonomics (auto-JSON `data`,
 * cancellation tokens, error-on-non-2xx).
 *
 * Use this instead of importing axios directly for app data requests. The
 * Bloomreach SPA SDK is the one intentional exception — it requires an
 * axios-compatible httpClient and is configured separately.
 */
import Axios from 'axios'
import { assertUrlAllowed } from './url-guard.js'

/**
 * Validated GET. Resolves + validates the URL, then issues axios.get against
 * the fully-resolved href that passed validation.
 */
export function get(url, config) {
  const resolvedHref = assertUrlAllowed(url)
  return Axios.get(resolvedHref, config)
}

// Re-export the cancellation helpers so call sites can rely solely on safeAxios
// without importing raw axios (CancelToken.source(), isCancel(err)).
export const CancelToken = Axios.CancelToken
export const isCancel = Axios.isCancel

export default { get, CancelToken, isCancel }
